/**
 * Created by ivan on 24.01.18.
 */

const ScaledProgressBar = cc.Node.extend({
    ctor: function (options) {
        this._super();
        this.options = options = { ...options.type, ...options };

        this.onChangeListener = options.onChange || function () {};

        this.progressFull = options.progressFull;
        this.progressCut = options.progressCut;
        this.sectorMode = this.progressFull && this.progressCut;

        this.progressFrames = options.progressFrames;
        this.layout = options.layout || ScaledProgressBar.HORIZONTAL;
        this.from = options.from || 0;
        this.to = options.to || 100;

        this.sizeDirty = true;

        if (options.background) {
            this.background = cleverapps.UI.createScale9Sprite(options.background);
            this.background.setAnchorPoint(0, 0);
            this.addChild(this.background, -2);
            this.applyCapInsets(this.background);
        }

        let progressFrame;
        if (this.sectorMode) {
            progressFrame = this.from >= this.to ? this.progressFull : this.progressCut;
        } else {
            progressFrame = options.progress;
        }

        this.progress = cleverapps.UI.createScale9Sprite(progressFrame);
        this.progress.setAnchorPoint(0, 0);
        this.addChild(this.progress);
        this.applyCapInsets(this.progress);

        this.sectorPadding = this.sectorMode ? this.getSectorPadding() : 0;

        const size = options.background ? cc.size(this.background.width, this.background.height) : cc.size(this.progress.width, this.progress.height);
        if (options.height) {
            size.height = options.height;
        }
        this.setContentSize2(size.width, size.height);
        this.setAnchorPoint(0.5, 0.5);

        if (options.barText) {
            this.createText(options.barText);
        }

        this.onChange();
    },

    createText: function (options) {
        options.font = options.font || cleverapps.styles.FONTS.SMALL_WHITE_TEXT;
        options.text = options.text || "%from%/%to%";

        this.barText = new TextWithIcon("", options);
        this.addChild(this.barText);
    },

    applyCapInsets: function (scale9Sprite) {
        if (this.layout === ScaledProgressBar.HORIZONTAL) {
            scale9Sprite.setCapInsets(cc.rect(scale9Sprite.width / 2 - 1, scale9Sprite.height / 3, 2, scale9Sprite.height / 3));
        } else {
            scale9Sprite.setCapInsets(cc.rect(scale9Sprite.width / 3, scale9Sprite.height / 2 - 1, scale9Sprite.width / 3, 2));
        }
    },

    onChange: function (silent) {
        if (this.background && this.sizeDirty) {
            this.background.setContentSize2(this.width, this.height);
        }

        if (this.barText && this.sizeDirty) {
            this.updateBarTextPosition();
        }

        if (this.barText) {
            this.barText.setString(this.options.barText.text
                .replace("%from%", Math.round(this.from))
                .replace("%to%", Math.round(this.to))
                .replace("%percentage%", Math.round(this.getPercentage())));
        }

        this.updateProgressFrame();

        if (this.sectorMode) {
            this.updateSectorProgress();
            this.updateDelimiters();
        } else {
            this.updateNormalProgress();
        }

        this.onChangeListener(silent);

        this.sizeDirty = false;
    },

    updateNormalProgress: function () {
        const size = cc.size(this.width, this.height);
        const minSize = this.options.minSize || cc.size(this.progress.getSpriteFrame().resolve().getOriginalSize());

        if (this.layout === ScaledProgressBar.HORIZONTAL) {
            size.width = (this.from > 0) ? Math.max(minSize.width, size.width * this.getPercentage() / 100) : 0;
        } else {
            size.height = (this.from > 0) ? Math.max(minSize.height, size.height * this.getPercentage() / 100) : 0;
        }

        this.progress.setContentSize(size.width, this.height);
    },

    getSectorPadding: function () {
        if (!this.options.background) {
            return 0;
        }

        const background = this.options.background.resolve();
        const full = this.progressFull.resolve();

        return Math.max(0, (background.getOriginalSize().width - full.getOriginalSize().width) / 2);
    },

    applySectorCapInsets: function () {
        const size = cc.size(this.progress.getSpriteFrame().resolve().getOriginalSize());
        const insetLeft = size.width / 2 - 1;
        const centerWidth = this.from >= this.to ? 2 : size.width - insetLeft - 1;

        this.progress.setCapInsets(cc.rect(insetLeft, size.height / 3, centerWidth, size.height / 3));
    },

    updateSectorProgress: function () {
        const totalWidth = Math.max(0, this.width - this.sectorPadding * 2);

        let progressLength;

        if (this.from >= this.to) {
            progressLength = totalWidth;
        } else if (this.from <= 0) {
            progressLength = 0;
        } else {
            progressLength = this.from * totalWidth / this.to;
        }

        this.applySectorCapInsets();

        this.progress.setPosition(this.sectorPadding, 0);
        this.progress.setContentSize(progressLength, this.height);
    },

    updateDelimiters: function () {
        if (this.delimiters) {
            this.delimiters.forEach((delimiter) => this.removeChild(delimiter));
        }

        this.delimiters = [];

        if (!this.options.delimiter) {
            return;
        }

        const totalWidth = Math.max(0, this.width - this.sectorPadding * 2);

        if (totalWidth === 0) {
            return;
        }

        const sectorWidth = totalWidth / this.to;

        const count = this.options.showAllDelimiters ? this.to : Math.min(this.from + 1, this.to);

        for (let i = 1; i < count; i++) {
            const xPos = this.sectorPadding + i * sectorWidth;

            const delimiter = cleverapps.UI.createSprite(this.options.delimiter);
            delimiter.setAnchorPoint(0.5, 0);
            delimiter.setPosition(xPos, 0);
            this.addChild(delimiter);
            this.delimiters.push(delimiter);
        }
    },

    getPercentage: function () {
        return this.from * 100 / this.to;
    },

    updateProgressFrame: function () {
        if (this.progressFrames) {
            let newFrame;
            for (const percent in this.progressFrames) {
                if (this.getPercentage() >= percent) {
                    newFrame = this.progressFrames[percent];
                }
            }
            if (newFrame && this.currentFrame !== newFrame) {
                this.currentFrame = newFrame;
                this.progress.setSpriteFrame(newFrame);
            }
        }
    },

    setLength: function (length, silent) {
        if (this.layout === ScaledProgressBar.VERTICAL) {
            this.setContentSize2(this.width, length);
        } else {
            this.setContentSize2(length, this.height);
        }
        this.sizeDirty = true;
        this.onChange(silent);
    },

    setLayout: function (layout) {
        this.layout = layout;
        this.onChange();
    },

    stopChangeAction: function () {
        if (this.changeAction && !this.changeAction.isDone()) {
            this.stopAction(this.changeAction);
            delete this.changeAction;
        }
    },

    _animatedChange: function (from, options) {
        if (from === this.from) {
            return;
        }

        from = Math.max(Math.min(from, this.to), 0);
        const delta = from - this.from;
        options = options || {};

        this.stopChangeAction();
        this.updateProgressFrame();

        const time = options.time !== undefined ? options.time : 0.8;
        let action = new ScaledProgressBarProgressTo(time, from);

        if (options.easing !== false) {
            action.easing(options.easing || cc.easeCubicActionOut());
        }

        if (options.callback) {
            action = new cc.Sequence(
                action,
                new cc.CallFunc(options.callback)
            );
        }
        this.changeAction = this.runAction(action);

        if (options.delta) {
            cleverapps.aims.showDelta(delta, this.getParent(), {
                x: this.width * from / this.to,
                y: this.height,
                font: cleverapps.styles.FONTS.MENUBAR_TEXT_DELTA || cleverapps.styles.FONTS.MENUBAR_TEXT
            });
        }
    },

    setGoal: function (to, silent) {
        this.to = to;
        this.onChange(silent);
    },

    getGoal: function () {
        return this.to;
    },

    setPercentage: function (from, options) {
        options = options || {};
        this.stopChangeAction();

        from = Math.max(Math.min(from, this.to), 0);

        if (this.from !== from) {
            if (options.animated && !this.sectorMode) {
                this._animatedChange(from, options);
            } else {
                this.from = from;
                this.onChange(true);
                options.callback && options.callback();
            }
        }
    },

    updateBarTextPosition: function () {
        this.barText.setAlignment(this.width / 2 + (this.options.barText.dx || 0), this.height / 2 + (this.options.barText.dy || 0));
    },

    updateBarText: function (text) {
        this.options.barText.text = text;
        this.barText.setString(text);
        this.onChange();
    },

    getDelimiter: function () {
        let delimiterFrame;
        for (const percent in this.options.delimiters) {
            if (this.getPercentage() >= percent) {
                delimiterFrame = this.options.delimiters[percent];
            }
        }

        if (delimiterFrame) {
            return cleverapps.UI.createSprite(delimiterFrame);
        }
    }
});

const ScaledProgressBarProgressTo = function (duration, percent) {
    cc.ActionInterval.prototype.constructor.call(this);

    this._from = 0;
    this._to = percent;
    this.initWithDuration(duration);
};

ScaledProgressBarProgressTo.prototype = Object.assign(Object.create(cc.ActionInterval.prototype), {
    constructor: ScaledProgressBarProgressTo,

    update: function (time) {
        if (!(this.target instanceof ScaledProgressBar)) {
            console.log(this.target, time);
            throw "Usage exception: ScaledProgressBarProgressTo should be used with ScaledProgressBar only.";
        }

        time = this._computeEaseTime(time);

        if (this._to < this._from) {
            this.target.from = Math.max(Math.min(this._from + (this._to - this._from) * time, this._from), this._to);
        } else {
            this.target.from = Math.max(Math.min(this._from + (this._to - this._from) * time, this._to), this._from);
        }

        this.target.onChange();
    },

    startWithTarget: function (target) {
        cc.ActionInterval.prototype.startWithTarget.call(this, target);
        this._from = target.from;
    }
});

ScaledProgressBar.HORIZONTAL = 0;
ScaledProgressBar.VERTICAL = 1;

ScaledProgressBar.Types = cleverapps.overrideTemplates({}, {
    blue: {
        progress: bundles.progress_bar.frames.bar_blue,
        background: bundles.progress_bar.frames.bg_dark
    },

    blue_with_frames: {
        progress: bundles.progress_bar.frames.bar_blue,
        background: bundles.progress_bar.frames.bg_dark,
        progressFrames: {
            0: bundles.progress_bar.frames.bar_red,
            30: bundles.progress_bar.frames.bar_orange,
            70: bundles.progress_bar.frames.bar_blue
        },
        delimiters: {
            0: bundles.progress_bar.frames.delimiter_red,
            30: bundles.progress_bar.frames.delimiter_orange,
            70: bundles.progress_bar.frames.delimiter_blue
        }
    },

    blue_small: {
        progress: bundles.progress_bar.frames.bar_blue_small,
        background: bundles.progress_bar.frames.bg_dark_small
    },

    blue_small_with_frames: {
        progress: bundles.progress_bar.frames.bar_blue_small,
        background: bundles.progress_bar.frames.bg_dark_small,
        progressFrames: {
            0: bundles.progress_bar.frames.bar_red_small,
            30: bundles.progress_bar.frames.bar_orange_small,
            70: bundles.progress_bar.frames.bar_blue_small
        }
    },

    blue_large_with_frames: {
        progress: bundles.progress_bar.frames.bar_blue_large,
        background: bundles.progress_bar.frames.bg_dark_large,
        progressFrames: {
            0: bundles.progress_bar.frames.bar_red_large,
            30: bundles.progress_bar.frames.bar_orange_large,
            70: bundles.progress_bar.frames.bar_blue_large
        }
    },

    green: {
        progress: bundles.progress_bar.frames.bar_green,
        background: bundles.progress_bar.frames.bg_green
    },

    green_large: {
        progress: bundles.progress_bar.frames.bar_green_large,
        background: bundles.progress_bar.frames.bg_green_large
    },

    red: {
        progress: bundles.progress_bar.frames.bar_red,
        background: bundles.progress_bar.frames.bg_dark
    },

    red_small: {
        progress: bundles.progress_bar.frames.bar_red_small,
        background: bundles.progress_bar.frames.bg_dark_small
    },

    blue_large_round: {
        progress: bundles.progress_bar.frames.bar_blue_large_round,
        background: bundles.progress_bar.frames.bg_green_large
    },

    green_small: {
        progress: bundles.progress_bar.frames.bar_green_small,
        background: bundles.progress_bar.frames.bg_dark_small
    },

    green_menu_bar_level: {
        progress: bundles.progress_bar.frames.bar_green_menu_bar_level,
        background: bundles.progress_bar.frames.bg_menu_bar_level
    },

    blue_menu_bar_level: {
        progress: bundles.progress_bar.frames.bar_blue_menu_bar_level,
        background: bundles.progress_bar.frames.bg_menu_bar_level
    },

    blue_sections_with_frames: {
        progressFull: bundles.progress_bar.frames.bar_blue_section,
        progressCut: bundles.progress_bar.frames.bar_blue_section_cut,
        background: bundles.progress_bar.frames.bg_section,
        progressFrames: {
            0: bundles.progress_bar.frames.bar_red_section_cut,
            30: bundles.progress_bar.frames.bar_orange_section_cut,
            70: bundles.progress_bar.frames.bar_blue_section_cut,
            100: bundles.progress_bar.frames.bar_blue_section
        },
        delimiter: bundles.progress_bar.frames.delimiter_section
    },

    blue_sections_with_frames_small: {
        progressFull: bundles.progress_bar.frames.bar_blue_section_small,
        progressCut: bundles.progress_bar.frames.bar_blue_section_cut_small,
        background: bundles.progress_bar.frames.bg_section_small,
        progressFrames: {
            0: bundles.progress_bar.frames.bar_red_section_cut_small,
            30: bundles.progress_bar.frames.bar_orange_section_cut_small,
            70: bundles.progress_bar.frames.bar_blue_section_cut_small,
            100: bundles.progress_bar.frames.bar_blue_section_small
        },
        delimiter: bundles.progress_bar.frames.delimiter_section_small
    }
});